import React, { FC } from "react";
import { CSVLink } from "react-csv";
import { FormControl, Typography } from "@mui/material";
import { GetFormControlSxProps } from "../toolbar/ToolbarSection";
import { StyledIconButton } from "./ToolbarIconButton";
import useProjectStore, { IDeviceInstance } from "common/store/ProjectStore";
import useDeviceStore from "common/store/DeviceStore";
import { getAllNetworks } from "common/utils/networkExtensions";

interface IToolbarButtonProps {
  icon: JSX.Element;
  label: string;
  disabled?: boolean;
}

const ToolbarExportButton: FC<IToolbarButtonProps> = ({ icon, label, disabled }) => {
  const { projectName: name, networkContainers } = useProjectStore();
  const { lookupCategory, lookupDeviceName, lookupExport, lookupBillTags } = useDeviceStore();

  const compileData = () => {
    var deviceList: IDeviceInstance[] = [];
    networkContainers.forEach((container) => {
      if(container.gatewayDeviceInstance) {
        deviceList = [...deviceList, container.gatewayDeviceInstance];
      }
    });
    getAllNetworks(networkContainers).forEach((network) => {
      deviceList = [...deviceList, ...network.deviceInstances];
    });
    // create object (iterate over map and create the export object)
    var exportDevices: string[][] = [["BillTag", "Device", "Device Id", "Category"]];
    deviceList.forEach((dev) => {
      if (lookupExport(dev.deviceID)) {
        var categoryId = lookupCategory(dev.deviceID);
        var deviceName = lookupDeviceName(dev.deviceID);
        var billTags = lookupBillTags(dev.deviceID);
        //if empty, else if one, else if more
        if (billTags.length < 1) {
          exportDevices = [
            ...exportDevices,
            ["", deviceName.toString(), dev.deviceID.toString(), categoryId.toString()],
          ];
        } else {
          billTags.forEach((tag) => {
            exportDevices = [
              ...exportDevices,
              [tag, deviceName.toString(), dev.deviceID.toString(), categoryId.toString()],
            ];
          });
        }
      }
    });

    return exportDevices;
  };

  const exportData = compileData();
  return (
    <FormControl sx={GetFormControlSxProps()}>
      <Typography variant="toolbarlabel">{label}</Typography>
      <CSVLink data={exportData} filename={`${name}.csv`}>
        <StyledIconButton disabled={disabled === true}>{icon}</StyledIconButton>
      </CSVLink>
    </FormControl>
  );
};

export default ToolbarExportButton;
